module.exports = __webpack_public_path__ + "static/media/1021353.02d4fe3b.png";